"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var cssAnchorName = 'ideation-statistics-bar';
exports.cssAnchorName = cssAnchorName;

var StatisticsBar = function StatisticsBar() {
  var handleClick = function handleClick(event) {
    event.preventDefault();
    var urlParams = new URLSearchParams(window.location.search);
    var productAreaId = urlParams.get('filters[productArea][0]');
    var p = (0, _globals.getSubfolderPrefix)();
    window.location.href = productAreaId ? "".concat(p, "/topic/new?type=idea&productAreaId=").concat(productAreaId) : "".concat(p, "/topic/new?type=idea");
  };

  return (0, _preact.h)("section", {
    className: (0, _classnames.default)('full-width', 'Template-brand-stats', 'custom-stats-bar')
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('stats-bar', 'p-v', 'qa-stats-bar')
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--stats-bar', 'qa-stats-bar')
  }), (0, _preact.h)("a", {
    className: "btn btn--cta",
    href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/topic/new?type=idea")),
    onClick: handleClick,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleClick(e);
    }
  }, (0, _preact.h)(_phrase.default, {
    p: "create.an.idea"
  }))))));
};

var _default = StatisticsBar;
exports.default = _default;